import { render, staticRenderFns } from "./NotificationHistoryPanel.vue?vue&type=template&id=321f8759&scoped=true"
import script from "./NotificationHistoryPanel.vue?vue&type=script&lang=js"
export * from "./NotificationHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationHistoryPanel.vue?vue&type=style&index=0&id=321f8759&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f8759",
  null
  
)

export default component.exports